<template>
  <box-model title="加工阶段概况">
    <template v-slot:content>
      <div class="select-part">
        <select-box :sty="false" :list="selList" :item="selItem" @sel="selEvent"></select-box>
      </div>
      <div class="con flex-between">
        <div class="item">
          <div class="it">加工中</div>
          <div class="ic flex-x-center">
            <img class="ic-img " src="../../assets/img/jia-gong-zhong.png" />
            <span class="txt">{{ detail.inProcessingNum || 0 }}<span class="t">件</span></span>
          </div>
        </div>
        <div class="item">
          <div class="it">加工完成</div>
          <div class="ic flex-x-center">
            <img class="ic-img " src="../../assets/img/jia-gong-done.png" />
            <span class="txt">{{ detail.processingCompletionNum || 0 }}<span class="t">件</span></span>
          </div>
        </div>
        <div class="item">
          <div class="it">质检完成</div>
          <div class="ic flex-x-center">
            <img class="ic-img " src="../../assets/img/zhi-jian-done.png" />
            <span class="txt">{{ detail.inspected || 0 }}<span class="t">件</span></span>
          </div>
        </div>
      </div>
    </template>
  </box-model>
</template>

<script>
  import { getProcessRecordStage } from "@/api/index";
  export default {
    data() {
      return {
        selList: [],
        selItem: {},
        detail: {}
      }
    },
    components: {
      "box-model": () => import("../../components/common/Model.vue"),
      "select-box": () => import("../../components/common/SelectBox.vue")
    },
    mounted(){
      this.getYearFn();
    },
    methods: {
      // 年份获取
      getYearFn(){
        const curYear = new Date().getFullYear();
        this.selList = [
          {name: `${curYear}年`, value: curYear},
          {name: `${curYear - 1}年`, value: curYear-1},
          {name: `${curYear - 2}年`, value: curYear-2}
        ];
        this.selItem = this.selList[0];
        this.getProcessRecordStageFn();
      },
      selEvent(item) {
        this.selItem = item;
        this.getProcessRecordStageFn();
      },
      getProcessRecordStageFn() {
        getProcessRecordStage({
          year: this.selItem.value
        }).then((res) => {
          this.detail = res.data || {};
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .select-part {
    position: absolute;
    top: -10px;
    right: 10px;
    width: 100px;
    font-size: 14px;
    font-weight: 400;
  }
  .con {
    width: 100%;
    height: 160px;
    padding-top: 10px;
    .item {
      width: 108px;
      height: 100%;
      padding-top: 20px;
      .it {
        font-size: 15px;
        font-weight: 400;
        color: rgba(255,255,255,0.8);
        line-height: 16px;
        text-align: center;
      }
      .ic {
        position: relative;
        width: 100%;
        height: 100px;
        margin-top: 14px;
        padding-top: 10px;
        .ic-img {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 0;
          width: 100%;
          height: 100%;
        }
        .txt {
          position: relative;
          z-index: 3;
          font-size: 24px;
          font-weight: 700;
          color: #FFFFFF;
          line-height: 20px;
          text-align: center;
          .t {
            font-size: 16px;
            font-weight: 400;
            color: #FFFFFF;
            margin-left: 8px;
          }
        }
      }
    }
  }
</style>